<ng-container
  *ngIf="(detectRouterPath === 'getphonenumber' && (breakpoints.small || breakpoints.extraSmall)); then phoneNumberScr ; else defaultApp">
</ng-container>


<ng-template #defaultApp>
  <div class="page_container">
   <app-header  [breakpoints]="breakpoints"></app-header> 
    <router-outlet></router-outlet>
    <app-footer [breakpoints]="breakpoints"></app-footer> 
  </div>
</ng-template>

<ng-template #phoneNumberScr>
  <div>
     <router-outlet></router-outlet>
     <web-prequal-footer></web-prequal-footer>
  </div>

</ng-template>


<router-outlet name="modal"></router-outlet>
<app-leave-site *ngIf="this.leaveSiteService.showPopup"></app-leave-site>